var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintenancePc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 366,
    viewBox: "0 0 382 366",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "exclusion"
    },
    d: "M195.461 366C190.947 366 186.802 365.04 183.789 363.304L13.6156 265.054C10.5095 263.26 8.79673 260.753 8.79883 257.991C8.79883 254.696 11.2429 251.396 15.4985 248.938L112.077 193.177C116.243 190.775 121.749 189.396 127.19 189.396C131.708 189.396 135.848 190.353 138.862 192.091L309.035 290.34C312.141 292.135 313.854 294.642 313.849 297.408C313.849 300.699 311.407 304.002 307.15 306.457L210.573 362.215C206.41 364.62 200.899 365.998 195.459 365.998L195.461 366ZM127.19 190.529C121.94 190.529 116.64 191.853 112.643 194.159L16.0639 249.919C12.1676 252.17 9.92944 255.112 9.92944 257.993C9.92944 260.33 11.4405 262.491 14.1809 264.075L184.354 362.325C187.197 363.966 191.14 364.872 195.456 364.872C200.706 364.872 206.006 363.548 210.003 361.242L306.58 305.482C310.481 303.231 312.717 300.289 312.717 297.408C312.717 295.071 311.208 292.91 308.465 291.324L138.294 193.076C135.451 191.433 131.51 190.531 127.188 190.531L127.19 190.529Z",
    fill: "url(#paint0_radial_17733_76152)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M108.103 166.331C113.63 163.141 120.59 161.431 127.557 161.508C130.373 161.542 133.053 161.903 135.541 162.484C138.216 163.108 141.333 164.375 143.483 165.617L313.008 263.495C318.838 266.861 321.883 272.195 321.53 277.993C321.431 279.605 321.053 281.173 320.498 282.715C319.015 286.845 314.82 291.246 310.062 293.994L214.864 348.958C213.645 349.662 212.033 350.465 210.686 351.018C206.117 352.895 200.924 353.952 195.668 353.979C189.641 354.013 184.135 352.718 179.816 350.226L9.64113 251.976C3.79672 248.601 0.774662 243.248 1.15504 237.446C1.24541 236.059 1.54806 234.71 1.96626 233.371C3.33648 228.991 7.67827 224.309 12.6694 221.428L108.103 166.329V166.331Z",
    fill: "url(#paint1_linear_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M108.529 167.069C114.041 163.888 121.033 162.23 127.924 162.385C130.734 162.454 133.388 162.891 135.845 163.499C138.301 164.106 141.771 165.613 143.706 166.731L312.583 264.232C318.385 267.582 321.117 272.893 320.405 278.544C320.212 280.082 319.722 281.558 319.136 283.043C317.688 286.717 312.858 291.393 308.577 293.869L214.754 348.038C213.657 348.673 211.858 349.587 210.647 350.091C206.16 351.964 201.051 353.063 195.877 353.12C189.947 353.185 184.489 351.939 180.244 349.488L10.0689 251.239C4.23917 247.872 1.54495 242.53 2.31412 236.866C2.49275 235.544 2.89838 234.271 3.35022 232.982C4.71202 229.084 9.7473 224.101 14.2383 221.508L108.529 167.069Z",
    fill: "url(#paint2_linear_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M108.956 167.806C114.451 164.633 121.479 163.027 128.292 163.261C131.095 163.364 133.725 163.878 136.148 164.511C138.274 165.066 142.208 166.848 143.93 167.842L312.157 264.969C317.932 268.304 320.359 273.586 319.279 279.094C318.993 280.557 318.392 281.935 317.772 283.373C316.383 286.596 310.896 291.543 307.09 293.742L214.641 347.117C213.665 347.68 211.679 348.71 210.606 349.164C206.203 351.032 201.174 352.173 196.082 352.257C190.246 352.356 184.838 351.154 180.667 348.748L10.4917 250.498C4.67669 247.14 2.30191 241.81 3.46827 236.283C3.73306 235.026 4.24374 233.835 4.72709 232.589C6.05527 229.165 11.8094 223.888 15.8023 221.583L108.951 167.804L108.956 167.806Z",
    fill: "url(#paint3_linear_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M109.379 168.544C114.86 165.379 121.919 163.826 128.657 164.137C131.452 164.275 134.056 164.864 136.449 165.526C138.303 166.037 142.645 168.086 144.152 168.956L311.729 265.707C317.477 269.025 319.608 274.275 318.154 279.644C317.777 281.029 317.065 282.309 316.409 283.702C315.1 286.481 308.936 291.695 305.605 293.617L214.53 346.2C213.677 346.694 211.504 347.838 210.569 348.241C206.248 350.103 201.303 351.288 196.293 351.402C190.552 351.532 185.195 350.378 181.097 348.012L10.9216 249.762C5.1213 246.412 3.05339 241.102 4.62955 235.705C4.97841 234.513 5.59418 233.41 6.11326 232.2C7.38049 229.247 13.8827 223.68 17.3755 221.662L109.381 168.542L109.379 168.544Z",
    fill: "url(#paint4_linear_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M109.805 169.28C115.271 166.123 122.364 164.623 129.024 165.011C131.812 165.184 134.389 165.85 136.753 166.537C138.336 166.997 143.083 169.32 144.373 170.066L311.302 266.443C317.022 269.746 318.871 274.962 317.026 280.193C316.564 281.503 315.738 282.679 315.044 284.031C313.842 286.374 306.972 291.842 304.116 293.492L214.416 345.28C213.685 345.703 211.327 346.964 210.526 347.315C206.287 349.172 201.426 350.4 196.496 350.543C190.851 350.707 185.543 349.599 181.518 347.275L11.343 249.025C5.55533 245.684 3.78164 240.39 5.78441 235.125C6.21313 234.001 6.93609 232.986 7.493 231.809C8.66987 229.321 15.9475 223.47 18.9401 221.741L109.805 169.28Z",
    fill: "url(#paint5_linear_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M110.232 170.02C115.684 166.872 122.808 165.424 129.392 165.89C132.174 166.096 134.722 166.838 137.059 167.555C138.372 167.956 143.523 170.56 144.599 171.182L310.878 267.183C316.571 270.47 318.149 275.659 315.903 280.746C315.358 281.98 314.654 283.212 313.683 284.361C313 286.446 305.012 291.994 302.633 293.368L214.307 344.365C213.698 344.718 211.155 346.096 210.489 346.393C206.332 348.246 201.553 349.515 196.707 349.686C191.157 349.881 185.899 348.822 181.948 346.54L11.7724 248.29C5.99944 244.957 4.50525 239.678 6.94515 234.546C7.44952 233.485 8.05896 232.421 8.87646 231.419C9.49432 229.208 18.0161 223.261 20.5107 221.819L110.232 170.018V170.02Z",
    fill: "url(#paint6_linear_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M110.657 170.756C116.094 167.617 123.249 166.221 129.76 166.765C132.536 167.007 135.052 167.823 137.363 168.567C138.41 168.903 143.964 171.797 144.824 172.293L310.454 267.919C316.119 271.192 317.441 276.355 314.778 281.296C314.154 282.456 313.366 283.614 312.322 284.69C311.775 286.358 303.052 292.142 301.15 293.241L214.2 343.443C213.713 343.724 210.985 345.225 210.453 345.465C206.376 347.314 201.684 348.625 196.917 348.825C191.462 349.054 186.254 348.039 182.374 345.801L12.1992 247.551C6.44099 244.227 5.21369 238.954 8.10332 233.965C8.68125 232.969 9.36846 231.964 10.2595 231.027C10.7534 229.259 20.0843 223.049 22.0807 221.895L110.659 170.754L110.657 170.756Z",
    fill: "url(#paint7_linear_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M111.084 171.495C116.504 168.363 123.696 167.02 130.129 167.643C132.898 167.918 135.382 168.809 137.669 169.58C138.451 169.845 144.404 173.033 145.05 173.405L310.03 268.656C315.668 271.911 316.744 277.062 313.655 281.845C312.953 282.932 312.081 284.016 310.961 285.018C310.551 286.269 301.092 292.292 299.665 293.116L214.09 342.523C213.724 342.735 210.811 344.356 210.416 344.539C206.421 346.384 201.81 347.737 197.126 347.964C191.767 348.225 186.606 347.258 182.802 345.062L12.6266 246.812C6.88307 243.496 5.90795 238.219 9.26203 233.383C9.91141 232.448 10.6806 231.509 11.6431 230.637C12.013 229.31 22.1529 222.84 23.6513 221.974L111.088 171.493L111.084 171.495Z",
    fill: "url(#paint8_linear_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M111.507 172.231C116.912 169.108 124.135 167.818 130.492 168.517C133.256 168.828 135.706 169.791 137.97 170.594C138.487 170.777 144.84 174.269 145.268 174.517L309.599 269.392C315.21 272.632 316.051 277.779 312.525 282.394C311.747 283.411 310.787 284.42 309.591 285.347C309.318 286.181 299.125 292.44 298.173 292.99L213.972 341.605C213.729 341.746 210.633 343.491 210.37 343.614C206.455 345.455 201.93 346.851 197.328 347.107C192.064 347.401 186.953 346.481 183.222 344.327L13.0472 246.077C7.31625 242.769 6.58701 237.474 10.4139 232.806C11.1327 231.93 11.9838 231.055 13.0178 230.248C13.2658 229.364 24.2127 222.632 25.2109 222.054L111.505 172.231H111.507Z",
    fill: "url(#paint9_linear_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M111.936 172.969C117.326 169.854 124.581 168.616 130.862 169.394C133.62 169.739 136.034 170.777 138.277 171.607C138.535 171.701 145.281 175.505 145.495 175.629L309.177 270.13C314.761 273.354 315.372 278.515 311.402 282.945C310.551 283.897 309.503 284.824 308.231 285.675C308.095 286.091 297.166 292.589 296.689 292.864L213.863 340.685C213.741 340.757 210.465 342.625 210.333 342.688C206.495 344.525 202.059 345.962 197.536 346.246C192.366 346.572 187.306 345.697 183.649 343.585L13.4739 245.336C7.75773 242.034 7.26595 236.709 11.572 232.222C12.3601 231.4 13.2953 230.597 14.4007 229.853C14.5247 229.412 26.2808 222.418 26.781 222.13L111.934 172.967L111.936 172.969Z",
    fill: "url(#paint10_linear_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.076 342.853L13.9024 244.601C7.18168 240.72 8.0244 233.944 15.7854 229.464L112.362 173.706C120.119 169.225 131.86 168.74 138.579 172.621L308.75 270.869C315.469 274.75 314.63 281.526 306.869 286.006L210.294 341.765C202.533 346.243 190.796 346.733 184.078 342.851L184.076 342.853Z",
    fill: "url(#paint11_linear_17733_76152)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.075 342.695L13.9014 244.448C10.9025 242.718 9.41462 240.413 9.36839 237.994C9.36418 237.916 9.36418 229.64 9.36839 229.565C9.41882 226.625 11.5918 231.729 15.7865 229.311L112.363 173.55C120.12 169.072 131.862 168.586 138.58 172.464L308.751 270.713C310.996 272.01 312.622 266.512 313.204 268.261C313.4 268.845 313.28 276.555 313.291 277.161C313.356 280.174 311.178 283.365 306.87 285.851L210.296 341.611C202.535 346.092 190.797 346.575 184.079 342.695H184.075Z",
    fill: "url(#paint12_linear_17733_76152)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.076 334.422L13.9024 236.172C7.18168 232.293 8.0244 225.515 15.7854 221.037L112.362 165.279C120.119 160.798 131.86 160.313 138.579 164.19L308.75 262.44C315.469 266.319 314.63 273.097 306.869 277.577L210.294 333.335C202.533 337.816 190.796 338.303 184.078 334.422H184.076Z",
    fill: "url(#paint13_linear_17733_76152)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.46 333.643C191.629 333.643 188.193 332.878 185.772 331.483L15.5988 233.233C14.5375 232.622 12.7617 231.338 12.7617 229.602C12.7617 227.866 14.5229 225.689 17.4797 223.98L114.056 168.222C117.633 166.158 122.421 164.971 127.185 164.971C131.02 164.971 134.46 165.74 136.873 167.135L307.046 265.385C308.11 265.996 309.881 267.283 309.881 269.014C309.881 270.746 308.12 272.929 305.163 274.638L208.586 330.394C205.01 332.462 200.226 333.643 195.458 333.643H195.46Z",
    fill: "url(#paint14_linear_17733_76152)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M306.867 276.173L210.292 331.933C202.531 336.412 190.794 336.899 184.076 333.016L13.9025 234.768C11.1138 233.158 9.64685 231.051 9.41988 228.814C9.06893 231.559 10.5358 234.23 13.9025 236.174L184.076 334.424C190.796 338.305 202.531 337.818 210.292 333.337L306.867 277.579C311.409 274.956 313.561 271.552 313.237 268.397C312.89 271.133 310.74 273.939 306.867 276.175V276.173Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M306.65 258.655L139.276 162.024C133.703 158.804 131.038 152.199 132.816 146.012L169.282 19.8814C171.796 11.1305 181.864 7.06825 189.751 11.6202L357.125 108.254C362.698 111.471 365.365 118.078 363.585 124.265L327.121 250.398C324.608 259.151 314.537 263.214 306.65 258.658V258.655Z",
    fill: "url(#paint15_linear_17733_76152)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M304.309 258.655L136.94 162.024C131.362 158.804 128.7 152.199 130.475 146.012L166.939 19.8814C169.457 11.1305 179.524 7.06825 187.411 11.6202L354.784 108.254C360.36 111.471 363.027 118.078 361.245 124.265L324.783 250.398C322.265 259.151 312.197 263.214 304.309 258.658V258.655Z",
    fill: "url(#paint16_linear_17733_76152)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "exclusion"
    },
    d: "M330.764 251.909C328.231 251.909 325.718 251.234 323.501 249.95L156.129 153.317C150.323 149.965 147.563 143.122 149.415 136.676L185.877 10.5435C187.665 4.3355 193.428 0 199.892 0C202.42 0 204.933 0.678801 207.151 1.95865L374.526 98.5943C380.333 101.948 383.094 108.789 381.243 115.234L344.779 241.369C342.993 247.575 337.228 251.911 330.764 251.911V251.909ZM199.892 1.10331C193.913 1.10331 188.588 5.11307 186.932 10.8482L150.474 136.981C148.761 142.939 151.31 149.267 156.68 152.365L324.054 248.998C326.105 250.183 328.425 250.81 330.764 250.81C336.741 250.81 342.07 246.802 343.72 241.063L380.182 114.93C381.895 108.972 379.343 102.646 373.976 99.5484L206.602 2.91275C204.551 1.72958 202.231 1.10542 199.892 1.10542V1.10331Z",
    fill: "url(#paint17_radial_17733_76152)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M311.297 255.859C309.66 255.859 308.098 255.436 306.652 254.602L139.278 157.969C135.559 155.819 133.789 151.437 134.979 147.31L171.441 21.1745C172.582 17.1962 176.278 14.418 180.427 14.418C182.064 14.418 183.625 14.8425 185.069 15.6768L352.441 112.308C356.163 114.458 357.93 118.838 356.743 122.969L320.281 249.102C319.138 253.081 315.439 255.859 311.295 255.859H311.297Z",
    fill: "url(#paint18_linear_17733_76152)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M311.119 255.531C309.488 255.531 307.933 255.111 306.491 254.279L139.72 157.994C136.013 155.853 134.25 151.486 135.437 147.373L171.79 21.6181C172.929 17.6546 176.611 14.8848 180.745 14.8848C182.375 14.8848 183.931 15.3072 185.37 16.1394L352.139 112.424C355.848 114.566 357.607 118.93 356.426 123.047L320.073 248.802C318.934 252.766 315.248 255.533 311.119 255.533V255.531Z",
    fill: "url(#paint19_linear_17733_76152)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M310.941 255.206C309.316 255.206 307.768 254.785 306.33 253.957L140.161 158.02C136.466 155.886 134.711 151.536 135.892 147.436L172.136 22.0597C173.27 18.1109 176.94 15.3516 181.059 15.3516C182.683 15.3516 184.234 15.774 185.67 16.602L351.837 112.538C355.532 114.671 357.286 119.021 356.11 123.121L319.866 248.496C318.729 252.444 315.06 255.204 310.943 255.204L310.941 255.206Z",
    fill: "url(#paint20_linear_17733_76152)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M310.764 254.882C309.146 254.882 307.601 254.464 306.17 253.638L140.603 158.049C136.923 155.922 135.173 151.589 136.35 147.505L172.484 22.5073C173.614 18.5732 177.271 15.8223 181.373 15.8223C182.992 15.8223 184.536 16.2426 185.967 17.0685L351.532 112.658C355.214 114.784 356.962 119.118 355.787 123.203L319.653 248.199C318.521 252.133 314.864 254.882 310.762 254.882H310.764Z",
    fill: "url(#paint21_linear_17733_76152)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M310.588 254.556C308.976 254.556 307.437 254.14 306.013 253.317L141.047 158.074C137.38 155.956 135.636 151.637 136.81 147.569L172.835 22.9508C173.964 19.0293 177.606 16.291 181.693 16.291C183.305 16.291 184.843 16.7092 186.27 17.5309L351.232 112.771C354.899 114.889 356.641 119.208 355.473 123.279L319.448 247.897C318.319 251.818 314.675 254.556 310.59 254.556H310.588Z",
    fill: "url(#paint22_linear_17733_76152)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M310.41 254.231C308.804 254.231 307.27 253.817 305.851 252.995L141.489 158.102C137.837 155.992 136.099 151.688 137.267 147.634L173.183 23.3944C174.307 19.4876 177.936 16.7598 182.009 16.7598C183.615 16.7598 185.149 17.178 186.569 17.9955L350.93 112.889C354.584 114.999 356.32 119.303 355.156 123.359L319.24 247.596C318.116 251.503 314.487 254.231 310.414 254.231H310.41Z",
    fill: "url(#paint23_linear_17733_76152)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M310.233 253.905C308.634 253.905 307.106 253.491 305.691 252.674L141.93 158.129C138.29 156.028 136.559 151.738 137.723 147.699L173.529 23.838C174.649 19.946 178.266 17.2266 182.324 17.2266C183.923 17.2266 185.451 17.6427 186.868 18.4581L350.625 113.003C354.265 115.106 355.996 119.393 354.834 123.435L319.028 247.294C317.906 251.186 314.291 253.903 310.233 253.903V253.905Z",
    fill: "url(#paint24_linear_17733_76152)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M310.056 253.58C308.463 253.58 306.941 253.168 305.531 252.354L142.373 158.157C138.748 156.061 137.02 151.789 138.18 147.764L173.877 24.2835C174.995 20.4062 178.597 17.6973 182.639 17.6973C184.232 17.6973 185.755 18.1113 187.165 18.9246L350.321 113.12C353.949 115.216 355.672 119.488 354.516 123.515L318.819 246.995C317.701 250.873 314.099 253.582 310.056 253.582V253.58Z",
    fill: "url(#paint25_linear_17733_76152)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M309.881 253.254C308.294 253.254 306.777 252.844 305.375 252.033L142.818 158.184C139.205 156.097 137.486 151.839 138.642 147.832L174.23 24.7292C175.344 20.8665 178.933 18.166 182.96 18.166C184.546 18.166 186.064 18.58 187.47 19.3891L350.022 113.238C353.637 115.325 355.354 119.581 354.2 123.595L318.613 246.695C317.499 250.558 313.912 253.256 309.881 253.256V253.254Z",
    fill: "url(#paint26_linear_17733_76152)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M309.703 252.928C308.123 252.928 306.612 252.521 305.215 251.712L143.261 158.209C139.663 156.131 137.948 151.888 139.1 147.895L174.58 25.1707C175.69 21.3228 179.264 18.6328 183.278 18.6328C184.859 18.6328 186.372 19.0447 187.771 19.8496L349.721 113.35C353.321 115.43 355.032 119.669 353.884 123.668L318.404 246.391C317.294 250.238 313.72 252.928 309.703 252.928Z",
    fill: "url(#paint27_linear_17733_76152)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.93,
    d: "M309.525 252.603C307.95 252.603 306.446 252.195 305.052 251.39L143.702 158.237C140.116 156.167 138.408 151.941 139.555 147.96L174.927 25.6144C176.034 21.7791 179.594 19.0996 183.593 19.0996C185.167 19.0996 186.674 19.5094 188.07 20.3122L349.418 113.466C353.006 115.538 354.71 119.762 353.567 123.746L318.196 246.09C317.088 249.926 313.528 252.603 309.529 252.603H309.525Z",
    fill: "url(#paint28_linear_17733_76152)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M309.348 252.277C307.781 252.277 306.28 251.872 304.893 251.069L144.143 158.262C140.573 156.199 138.868 151.989 140.014 148.024L175.276 26.058C176.379 22.2373 179.927 19.5684 183.909 19.5684C185.477 19.5684 186.979 19.9761 188.368 20.7768L349.114 113.581C352.687 115.645 354.387 119.854 353.246 123.822L317.984 245.786C316.88 249.606 313.335 252.275 309.348 252.275V252.277Z",
    fill: "url(#paint29_linear_17733_76152)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M354.784 108.251L187.41 11.6173C184.346 9.84988 180.96 9.39384 177.814 9.99489C180.643 9.68176 183.611 10.2071 186.319 11.7749L353.693 108.408C359.267 111.626 361.931 118.231 360.149 124.42L323.691 250.551C322.149 255.906 317.78 259.491 312.816 260.439C318.221 259.844 323.132 256.141 324.782 250.398L361.244 124.265C363.026 118.076 360.359 111.47 354.784 108.253V108.251Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M288.69 301.416C296.409 320.197 279.729 344.85 251.434 356.478C223.138 368.104 193.946 362.306 186.225 343.522C178.508 324.741 195.186 300.087 223.481 288.459C251.776 276.834 280.973 282.63 288.69 301.416Z",
    fill: "url(#paint30_radial_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M148.697 186.801C153.203 199.9 138.868 216.704 116.684 224.339C94.498 231.968 72.8604 227.535 68.3547 214.436C63.8448 201.335 78.1816 184.529 100.368 176.899C122.552 169.266 144.191 173.7 148.697 186.801Z",
    fill: "url(#paint31_radial_17733_76152)"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M214.314 298.233L76.1262 218.448C73.3585 216.851 73.7053 214.06 76.9038 212.215L128.785 182.261C131.981 180.414 136.815 180.216 139.583 181.814L277.77 261.597C280.538 263.196 280.191 265.985 276.997 267.83L225.114 297.788C221.913 299.629 217.088 299.832 214.316 298.233H214.314Z",
    fill: "url(#paint32_linear_17733_76152)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M131.812 188.091L140.666 193.206C141.788 193.856 143.614 193.86 144.73 193.213C145.85 192.566 145.844 191.515 144.72 190.865L135.862 185.752C134.737 185.103 132.92 185.101 131.799 185.746C130.677 186.393 130.686 187.444 131.814 188.093L131.812 188.091ZM146.973 196.846L151.167 199.267C152.292 199.919 154.107 199.923 155.23 199.276C156.35 198.628 156.348 197.578 155.217 196.928L151.022 194.505C149.898 193.854 148.078 193.85 146.958 194.497C145.836 195.144 145.844 196.193 146.973 196.844V196.846ZM157.472 202.907L161.662 205.33C162.791 205.98 164.613 205.986 165.729 205.339C166.851 204.691 166.843 203.641 165.718 202.991L161.524 200.57C160.397 199.919 158.579 199.915 157.457 200.562C156.337 201.209 156.345 202.26 157.472 202.909V202.907ZM167.969 208.97L172.164 211.393C173.29 212.043 175.112 212.045 176.23 211.4C177.348 210.752 177.346 209.702 176.218 209.052L172.023 206.631C170.899 205.98 169.077 205.978 167.957 206.623C166.839 207.27 166.843 208.321 167.967 208.97H167.969ZM178.473 215.035L182.667 217.454C183.792 218.104 185.618 218.108 186.734 217.46C187.854 216.813 187.848 215.765 186.719 215.113L182.529 212.692C181.402 212.043 179.58 212.038 178.462 212.686C177.342 213.331 177.35 214.382 178.475 215.035H178.473ZM188.974 221.094L193.169 223.517C194.295 224.169 196.117 224.173 197.235 223.526C198.353 222.88 198.345 221.828 197.221 221.178L193.026 218.757C191.902 218.104 190.082 218.104 188.962 218.749C187.839 219.396 187.848 220.445 188.972 221.094H188.974ZM199.478 227.157L203.672 229.58C204.797 230.23 206.615 230.234 207.735 229.589C208.857 228.943 208.853 227.89 207.724 227.241L203.529 224.822C202.403 224.171 200.585 224.167 199.465 224.812C198.345 225.459 198.353 226.51 199.48 227.159L199.478 227.157ZM209.979 233.222L214.17 235.643C215.296 236.29 217.114 236.295 218.236 235.649C219.354 235.002 219.35 233.953 218.224 233.304L214.025 230.881C212.902 230.23 211.083 230.225 209.964 230.873C208.84 231.518 208.849 232.571 209.977 233.222H209.979ZM220.476 239.283L224.673 241.704C225.798 242.353 227.618 242.358 228.738 241.71C229.858 241.065 229.851 240.014 228.727 239.363L224.528 236.942C223.404 236.293 221.584 236.288 220.464 236.936C219.346 237.581 219.35 238.632 220.476 239.283ZM230.98 245.346L235.175 247.767C236.299 248.418 238.123 248.423 239.239 247.775C240.359 247.13 240.351 246.079 239.226 245.428L235.032 243.005C233.905 242.358 232.087 242.353 230.965 243.001C229.845 243.648 229.851 244.695 230.98 245.346ZM241.481 251.409L245.674 253.83C246.803 254.481 248.62 254.486 249.743 253.838C250.861 253.191 250.856 252.138 249.728 251.491L245.533 249.068C244.409 248.418 242.589 248.414 241.467 249.059C240.347 249.709 240.349 250.76 241.479 251.407L241.481 251.409ZM251.985 257.474L256.178 259.895C257.302 260.544 259.124 260.547 260.242 259.901C261.362 259.254 261.358 258.203 260.225 257.556L256.035 255.133C254.908 254.481 253.09 254.479 251.97 255.127C250.848 255.774 250.856 256.823 251.985 257.476V257.474ZM262.701 263.661L266.895 266.084C268.022 266.733 269.842 266.74 270.96 266.092C272.08 265.445 272.074 264.392 270.949 263.745L266.755 261.322C265.626 260.67 263.806 260.668 262.688 261.316C261.568 261.961 261.574 263.012 262.699 263.661H262.701ZM122.368 193.868L125.999 195.966C127.277 196.706 129.351 196.71 130.623 195.976L134.233 193.892C135.504 193.158 135.496 191.96 134.216 191.223L130.585 189.125C129.303 188.386 127.233 188.381 125.961 189.117L122.351 191.2C121.073 191.935 121.084 193.131 122.368 193.871V193.868ZM141.124 202.037L144.732 199.952C146.008 199.219 146 198.021 144.718 197.281L141.086 195.184C139.804 194.444 137.734 194.438 136.456 195.178L132.852 197.26C131.577 197.996 131.583 199.192 132.867 199.931L136.498 202.029C137.778 202.769 139.848 202.773 141.124 202.037ZM143.366 205.992L147 208.092C148.282 208.832 150.352 208.834 151.623 208.098L155.234 206.015C156.509 205.282 156.501 204.084 155.217 203.342L151.588 201.247C150.304 200.503 148.234 200.503 146.962 201.239L143.352 203.321C142.08 204.057 142.084 205.255 143.366 205.992ZM153.868 212.055L157.499 214.151C158.783 214.89 160.853 214.895 162.127 214.161L165.733 212.078C167.011 211.343 167 210.145 165.723 209.405L162.091 207.31C160.805 206.57 158.737 206.566 157.461 207.302L153.853 209.384C152.582 210.12 152.588 211.316 153.868 212.055ZM176.22 215.466L172.588 213.369C171.309 212.631 169.234 212.625 167.967 213.362L164.357 215.445C163.081 216.181 163.085 217.376 164.367 218.118L168.003 220.214C169.283 220.955 171.355 220.957 172.628 220.222L176.232 218.141C177.51 217.404 177.502 216.208 176.22 215.468V215.466ZM186.719 221.529L183.092 219.432C181.81 218.692 179.738 218.688 178.466 219.425L174.858 221.508C173.582 222.244 173.585 223.439 174.869 224.181L178.504 226.277C179.784 227.018 181.858 227.02 183.13 226.285L186.738 224.2C188.01 223.467 188.005 222.267 186.719 221.527V221.529ZM197.223 227.592L193.593 225.497C192.309 224.755 190.239 224.753 188.964 225.486L185.357 227.569C184.082 228.304 184.088 229.5 185.37 230.242L189.006 232.339C190.283 233.077 192.353 233.083 193.629 232.348L197.237 230.263C198.511 229.528 198.507 228.332 197.223 227.59V227.592ZM207.724 233.657L204.093 231.56C202.809 230.82 200.739 230.814 199.467 231.549L195.855 233.634C194.587 234.37 194.59 235.565 195.874 236.307L199.505 238.402C200.789 239.142 202.859 239.146 204.133 238.411L207.743 236.328C209.01 235.593 209.006 234.399 207.724 233.657ZM218.226 239.72L214.596 237.623C213.314 236.883 211.238 236.879 209.967 237.616L206.36 239.697C205.087 240.435 205.091 241.63 206.377 242.37L210.004 244.465C211.288 245.205 213.358 245.207 214.634 244.474L218.24 242.391C219.518 241.654 219.51 240.46 218.228 239.72H218.226ZM228.729 245.783L225.094 243.684C223.814 242.946 221.744 242.942 220.468 243.675L216.86 245.76C215.588 246.493 215.594 247.691 216.874 248.433L220.506 250.53C221.788 251.27 223.86 251.274 225.136 250.539L228.742 248.454C230.017 247.721 230.011 246.523 228.731 245.783H228.729ZM227.376 254.494L231.003 256.593C232.287 257.333 234.361 257.335 235.633 256.602L239.241 254.519C240.519 253.782 240.511 252.586 239.226 251.846L235.595 249.749C234.313 249.009 232.241 249.003 230.965 249.74L227.359 251.823C226.083 252.558 226.09 253.756 227.374 254.494H227.376ZM249.728 257.907L246.096 255.812C244.812 255.07 242.742 255.068 241.471 255.801L237.863 257.888C236.591 258.619 236.593 259.819 237.873 260.557L241.509 262.654C242.791 263.392 244.856 263.396 246.136 262.661L249.743 260.578C251.018 259.842 251.008 258.647 249.728 257.907ZM265.107 266.786L256.816 262.001C255.534 261.259 253.462 261.255 252.187 261.99L248.578 264.073C247.307 264.808 247.313 266.004 248.597 266.746L256.89 271.533C258.17 272.275 260.24 272.279 261.513 271.542L265.12 269.459C266.395 268.724 266.387 267.528 265.107 266.786ZM112.637 199.482L120.926 204.267C122.214 205.009 124.28 205.013 125.556 204.275L129.164 202.195C130.435 201.459 130.429 200.261 129.149 199.524L120.855 194.736C119.575 193.995 117.505 193.99 116.227 194.728L112.619 196.811C111.347 197.546 111.355 198.742 112.637 199.484V199.482ZM127.8 208.235L131.43 210.332C132.714 211.072 134.784 211.076 136.057 210.34L139.665 208.256C140.937 207.518 140.933 206.324 139.651 205.585L136.019 203.485C134.735 202.745 132.665 202.743 131.394 203.479L127.785 205.562C126.508 206.297 126.516 207.495 127.8 208.235ZM141.931 216.395C143.213 217.135 145.285 217.139 146.556 216.403L150.165 214.321C151.44 213.585 151.434 212.387 150.15 211.646L146.519 209.55C145.239 208.811 143.165 208.804 141.893 209.54L138.285 211.624C137.013 212.36 137.018 213.556 138.299 214.296L141.931 216.393V216.395ZM152.43 222.458C153.714 223.198 155.784 223.202 157.056 222.464L160.668 220.384C161.94 219.648 161.934 218.452 160.652 217.711L157.02 215.617C155.74 214.873 153.666 214.871 152.39 215.607L148.784 217.692C147.513 218.425 147.521 219.623 148.801 220.361L152.43 222.458ZM162.898 221.67L159.292 223.75C158.014 224.486 158.023 225.682 159.302 226.424L162.934 228.519C164.218 229.259 166.288 229.263 167.564 228.529L171.172 226.443C172.443 225.709 172.437 224.511 171.153 223.774L167.526 221.676C166.244 220.936 164.172 220.934 162.898 221.67ZM173.62 227.603L169.566 229.942C168.413 230.608 168.421 231.686 169.577 232.356L173.656 234.71C174.816 235.378 176.686 235.383 177.84 234.718L181.89 232.379C183.044 231.715 183.035 230.635 181.879 229.967L177.8 227.611C176.644 226.945 174.77 226.941 173.62 227.605V227.603ZM184.122 233.666L180.066 236.005C178.918 236.669 178.925 237.751 180.08 238.417L184.16 240.773C185.317 241.441 187.192 241.443 188.342 240.779L192.393 238.442C193.547 237.778 193.539 236.696 192.381 236.028L188.304 233.674C187.148 233.004 185.275 233.004 184.122 233.666ZM194.621 239.729L190.569 242.07C189.418 242.734 189.426 243.812 190.582 244.482L194.661 246.834C195.817 247.504 197.691 247.506 198.841 246.842L202.895 244.505C204.047 243.841 204.038 242.757 202.882 242.091L198.803 239.735C197.647 239.069 195.775 239.064 194.621 239.729ZM205.122 245.792L201.071 248.131C199.919 248.797 199.925 249.877 201.085 250.541L205.16 252.897C206.322 253.565 208.193 253.569 209.34 252.905L213.396 250.568C214.548 249.902 214.54 248.822 213.384 248.152L209.303 245.798C208.149 245.13 206.274 245.125 205.122 245.792ZM215.622 251.852L211.572 254.191C210.423 254.858 210.427 255.94 211.587 256.608L215.662 258.962C216.818 259.63 218.692 259.634 219.842 258.968L223.896 256.629C225.049 255.965 225.041 254.885 223.881 254.217L219.806 251.863C218.646 251.195 216.776 251.19 215.622 251.854V251.852ZM230.347 265.031L234.401 262.692C235.551 262.026 235.547 260.948 234.387 260.277L230.31 257.924C229.154 257.253 227.277 257.251 226.13 257.917L222.074 260.254C220.922 260.918 220.93 262.001 222.088 262.671L226.167 265.025C227.325 265.693 229.196 265.695 230.347 265.031ZM240.847 271.094L244.899 268.753C246.052 268.087 246.044 267.009 244.888 266.338L240.809 263.983C239.649 263.316 237.783 263.312 236.629 263.978L232.575 266.317C231.426 266.981 231.434 268.062 232.59 268.732L236.665 271.086C237.825 271.754 239.699 271.756 240.847 271.094ZM255.608 272.527L251.529 270.174C250.373 269.505 248.498 269.501 247.347 270.167L243.295 272.504C242.146 273.171 242.146 274.251 243.308 274.921L247.385 277.275C248.541 277.941 250.415 277.945 251.565 277.281L255.621 274.942C256.772 274.278 256.764 273.198 255.608 272.53V272.527ZM102.689 204.965L115.855 212.564C117.013 213.232 118.885 213.236 120.039 212.572L124.087 210.235C125.243 209.571 125.236 208.487 124.076 207.821L110.908 200.219C109.752 199.549 107.88 199.545 106.726 200.211L102.672 202.55C101.522 203.214 101.529 204.296 102.687 204.965H102.689ZM122.275 216.275L126.354 218.627C127.514 219.297 129.385 219.297 130.534 218.633L134.588 216.294C135.738 215.632 135.733 214.552 134.578 213.882L130.499 211.526C129.338 210.86 127.466 210.857 126.314 211.519L122.265 213.858C121.111 214.523 121.119 215.605 122.275 216.275ZM132.779 222.336L136.856 224.694C138.014 225.362 139.884 225.364 141.036 224.698L145.09 222.359C146.243 221.695 146.237 220.615 145.075 219.942L141 217.589C139.844 216.92 137.97 216.916 136.818 217.584L132.766 219.921C131.614 220.585 131.621 221.668 132.781 222.336H132.779ZM143.28 228.399L147.359 230.753C148.519 231.421 150.388 231.425 151.537 230.761L155.591 228.422C156.743 227.758 156.736 226.676 155.576 226.01L151.501 223.654C150.341 222.985 148.473 222.981 147.319 223.647L143.265 225.984C142.116 226.651 142.124 227.731 143.28 228.399ZM162.041 236.824L166.092 234.485C167.248 233.819 167.236 232.741 166.08 232.073L162.005 229.719C160.841 229.051 158.97 229.046 157.823 229.71L153.771 232.049C152.617 232.711 152.626 233.796 153.784 234.464L157.861 236.818C159.021 237.486 160.891 237.49 162.041 236.824ZM172.542 242.887L176.596 240.548C177.746 239.884 177.737 238.806 176.581 238.138L172.502 235.78C171.348 235.114 169.474 235.109 168.32 235.773L164.27 238.112C163.117 238.777 163.121 239.859 164.285 240.525L168.36 242.881C169.516 243.549 171.388 243.551 172.54 242.887H172.542ZM183.046 248.95L187.095 246.611C188.245 245.945 188.241 244.865 187.085 244.194L183.006 241.841C181.846 241.174 179.975 241.17 178.822 241.834L174.772 244.173C173.622 244.835 173.622 245.92 174.787 246.588L178.862 248.944C180.019 249.612 181.89 249.614 183.046 248.95ZM193.547 255.013L197.597 252.672C198.748 252.008 198.742 250.926 197.582 250.259L193.507 247.906C192.347 247.235 190.477 247.233 189.327 247.897L185.278 250.236C184.12 250.9 184.128 251.981 185.284 252.649L189.363 255.005C190.523 255.673 192.393 255.675 193.547 255.011V255.013ZM204.042 261.074L208.1 258.737C209.25 258.073 209.242 256.991 208.086 256.322L204.007 253.969C202.851 253.302 200.978 253.296 199.824 253.96L195.771 256.297C194.621 256.963 194.625 258.046 195.785 258.712L199.864 261.068C201.02 261.736 202.893 261.738 204.042 261.074ZM214.546 267.139L218.602 264.798C219.754 264.134 219.747 263.056 218.585 262.385L214.508 260.032C213.35 259.361 211.48 259.359 210.328 260.025L206.276 262.362C205.125 263.026 205.131 264.109 206.289 264.777L210.368 267.133C211.526 267.799 213.396 267.805 214.548 267.141L214.546 267.139ZM216.79 270.84L220.865 273.194C222.023 273.862 223.891 273.866 225.049 273.2L229.099 270.861C230.249 270.197 230.244 269.117 229.084 268.446L225.009 266.09C223.849 265.422 221.979 265.42 220.825 266.084L216.776 268.423C215.622 269.087 215.63 270.169 216.79 270.838V270.84ZM245.882 278.143L235.511 272.153C234.353 271.485 232.483 271.481 231.329 272.147L227.277 274.488C226.13 275.152 226.132 276.232 227.294 276.899L237.659 282.886C238.819 283.556 240.689 283.558 241.841 282.892L245.897 280.555C247.051 279.891 247.042 278.809 245.882 278.143ZM93.0026 210.868L111.688 221.655C112.991 222.41 115.109 222.414 116.41 221.664L119.921 219.636C121.218 218.885 121.216 217.664 119.907 216.908L101.226 206.125C99.9147 205.37 97.8005 205.364 96.5039 206.116L92.9879 208.142C91.6892 208.895 91.6934 210.113 93.0026 210.87V210.868ZM118.65 225.675L122.189 227.716C123.494 228.475 125.61 228.475 126.911 227.727L130.423 225.696C131.722 224.946 131.717 223.727 130.41 222.971L126.873 220.932C125.564 220.178 123.446 220.171 122.151 220.922L118.639 222.952C117.339 223.702 117.345 224.923 118.65 225.675ZM129.154 231.738L132.684 233.781C133.996 234.536 136.114 234.54 137.415 233.787L140.922 231.759C142.225 231.009 142.217 229.788 140.912 229.034L137.373 226.991C136.066 226.234 133.951 226.234 132.646 226.985L129.139 229.013C127.838 229.763 127.844 230.982 129.154 231.738ZM139.655 237.801L143.192 239.844C144.499 240.599 146.611 240.605 147.91 239.853L151.424 237.827C152.722 237.072 152.716 235.853 151.407 235.097L147.874 233.054C146.565 232.3 144.451 232.295 143.156 233.046L139.638 235.074C138.339 235.826 138.346 237.045 139.655 237.801ZM150.159 243.866L153.689 245.907C155.001 246.662 157.115 246.666 158.416 245.915L161.927 243.887C163.226 243.137 163.218 241.916 161.908 241.158L158.373 239.117C157.066 238.363 154.954 238.36 153.651 239.109L150.144 241.137C148.841 241.887 148.847 243.108 150.159 243.864V243.866ZM160.656 249.927L164.195 251.97C165.498 252.725 167.616 252.729 168.915 251.978L172.427 249.95C173.727 249.198 173.721 247.979 172.412 247.223L168.879 245.182C167.57 244.428 165.452 244.423 164.155 245.174L160.641 247.204C159.34 247.954 159.346 249.175 160.656 249.929V249.927ZM171.155 255.99L174.694 258.031C176.001 258.788 178.115 258.79 179.421 258.039L182.928 256.011C184.227 255.261 184.225 254.04 182.913 253.284L179.378 251.243C178.071 250.491 175.953 250.484 174.652 251.237L171.14 253.265C169.842 254.015 169.846 255.236 171.155 255.99ZM181.661 262.051L185.193 264.094C186.503 264.848 188.617 264.855 189.92 264.102L193.429 262.076C194.73 261.324 194.722 260.103 193.413 259.349L189.884 257.308C188.571 256.551 186.457 256.549 185.158 257.298L181.644 259.325C180.345 260.078 180.347 261.297 181.661 262.053V262.051ZM192.164 268.116L195.699 270.157C197.002 270.913 199.116 270.916 200.417 270.165L203.929 268.139C205.23 267.385 205.225 266.166 203.914 265.409L200.379 263.367C199.068 262.612 196.958 262.608 195.657 263.36L192.145 265.386C190.845 266.137 190.851 267.36 192.164 268.114V268.116ZM202.666 274.177L206.199 276.22C207.506 276.974 209.618 276.979 210.921 276.228L214.432 274.2C215.729 273.45 215.727 272.229 214.413 271.475L210.883 269.432C209.574 268.677 207.457 268.673 206.161 269.423L202.649 271.454C201.35 272.204 201.354 273.423 202.666 274.179V274.177ZM213.161 280.242L216.696 282.281C218.003 283.037 220.121 283.044 221.42 282.291L224.934 280.265C226.233 279.513 226.228 278.29 224.917 277.535L221.384 275.495C220.077 274.74 217.959 274.736 216.658 275.484L213.15 277.514C211.847 278.263 211.856 279.484 213.161 280.242ZM235.65 283.733L232.115 281.692C230.808 280.934 228.698 280.932 227.393 281.68L223.885 283.708C222.584 284.46 222.591 285.681 223.896 286.438L227.435 288.478C228.74 289.235 230.856 289.239 232.153 288.489L235.669 286.459C236.965 285.708 236.963 284.487 235.65 283.733ZM99.694 216.466L91.5001 211.736C90.1908 210.981 88.0724 210.975 86.7737 211.727L83.2661 213.753C81.9611 214.504 81.9674 215.727 83.2767 216.479L91.4706 221.212C92.7841 221.966 94.8982 221.97 96.197 221.22L99.7087 219.19C101.01 218.442 101.003 217.219 99.694 216.462V216.466ZM110.195 222.529L106.661 220.487C105.353 219.734 103.235 219.728 101.934 220.48L98.4226 222.508C97.1259 223.259 97.128 224.48 98.4373 225.238L101.972 227.277C103.279 228.031 105.4 228.038 106.698 227.285L110.21 225.259C111.511 224.507 111.505 223.288 110.195 222.532V222.529ZM120.697 228.592L117.164 226.552C115.855 225.797 113.734 225.793 112.438 226.545L108.924 228.573C107.625 229.324 107.632 230.547 108.941 231.301L112.476 233.344C113.783 234.096 115.899 234.103 117.202 233.35L120.712 231.322C122.01 230.572 122.006 229.351 120.697 228.595V228.592ZM194.203 271.033L127.664 232.617C126.356 231.86 124.242 231.856 122.941 232.608L119.43 234.636C118.129 235.389 118.135 236.608 119.444 237.364L185.986 275.783C187.293 276.537 189.409 276.541 190.706 275.789L194.222 273.765C195.521 273.013 195.516 271.792 194.203 271.037V271.033ZM204.706 277.096L201.174 275.056C199.864 274.299 197.75 274.295 196.449 275.047L192.938 277.073C191.637 277.823 191.641 279.044 192.952 279.801L196.487 281.844C197.794 282.598 199.909 282.604 201.209 281.85L204.721 279.824C206.022 279.072 206.016 277.851 204.706 277.096ZM215.208 283.157L211.673 281.116C210.364 280.36 208.25 280.356 206.951 281.108L203.439 283.136C202.138 283.886 202.145 285.109 203.454 285.864L206.989 287.907C208.294 288.661 210.41 288.665 211.713 287.913L215.223 285.885C216.521 285.135 216.519 283.914 215.208 283.157ZM225.928 289.348L222.393 287.306C221.082 286.551 218.967 286.547 217.671 287.299L214.159 289.327C212.858 290.077 212.865 291.299 214.174 292.055L217.709 294.096C219.016 294.85 221.13 294.854 222.431 294.104L225.943 292.074C227.241 291.326 227.237 290.103 225.928 289.348Z",
    fill: "url(#paint33_linear_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "exclusion"
    },
    d: "M110.304 194.207L67.7437 169.636C65.5539 168.371 64.3477 166.591 64.3477 164.632C64.3477 162.302 66.0541 159.984 69.0383 158.26L118.292 129.824L118.858 130.806L69.6057 159.242C66.983 160.755 65.4804 162.72 65.4804 164.632C65.4804 166.173 66.487 167.602 68.3154 168.655L110.872 193.226L110.304 194.207Z",
    fill: "url(#paint34_radial_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M86.5234 155.349C86.5234 161.795 81.299 167.019 74.8514 167.019C68.4039 167.019 63.1836 161.797 63.1836 155.349C63.1836 148.902 68.4081 143.682 74.8514 143.682C81.2948 143.682 86.5234 148.906 86.5234 155.349Z",
    fill: "url(#paint35_radial_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M330.77 67.2793C330.77 73.7226 325.545 78.9492 319.102 78.9492C312.659 78.9492 307.428 73.7247 307.428 67.2793C307.428 60.8338 312.656 55.6094 319.102 55.6094C325.547 55.6094 330.77 60.8317 330.77 67.2793Z",
    fill: "url(#paint36_radial_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M254.614 343.076C254.614 349.524 249.389 354.746 242.942 354.746C236.494 354.746 231.27 349.526 231.27 343.076C231.27 336.626 236.498 331.408 242.942 331.408C249.385 331.408 254.614 336.628 254.614 343.076Z",
    fill: "url(#paint37_radial_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3,
    d: "M161.32 261.021C163.915 268.345 147.782 280.75 125.283 288.732C102.781 296.711 82.4361 297.243 79.8365 289.919C77.2411 282.595 93.3747 270.19 115.876 262.208C138.375 254.228 158.722 253.697 161.32 261.021Z",
    fill: "url(#paint38_radial_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3,
    d: "M266.447 293.434C261.836 300.86 244.914 298.7 228.648 288.606C212.382 278.513 202.936 264.308 207.544 256.879C212.155 249.452 229.075 251.613 245.341 261.706C261.605 271.8 271.053 286.005 266.445 293.434H266.447Z",
    fill: "url(#paint39_radial_17733_76152)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M167.244 141.412C167.244 144.537 162.279 147.069 156.159 147.069C150.04 147.069 145.072 144.537 145.072 141.412C145.072 138.286 150.035 135.754 156.159 135.754C162.283 135.754 167.244 138.286 167.244 141.412Z",
    fill: "url(#paint40_linear_17733_76152)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M224.57 256.954V255.098H224.543C223.719 261.212 218.906 267.477 210.249 272.475L187.695 285.498C170.251 295.567 143.864 296.662 128.758 287.938L97.1987 269.716C90.8946 266.076 87.5936 261.3 87.1066 256.24V258.496H87.132C86.2987 264.703 89.5881 270.748 97.1987 275.143L128.756 293.363C143.864 302.084 170.248 300.994 187.692 290.921L210.249 277.899C220.6 271.923 225.475 264.126 224.573 256.956L224.57 256.954Z",
    fill: "url(#paint41_linear_17733_76152)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M169.653 141.858C169.653 146.2 163.612 149.715 156.161 149.715C148.709 149.715 142.666 146.2 142.666 141.858C142.666 137.516 148.707 134 156.161 134C163.614 134 169.653 137.518 169.653 141.858Z",
    fill: "url(#paint42_linear_17733_76152)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M224.569 249.01V247.154H87.1027V250.552H87.1281C86.2948 256.759 89.5842 262.809 97.1948 267.202L128.752 285.42C143.86 294.14 170.244 293.049 187.689 282.98L210.246 269.954C220.596 263.98 225.471 256.184 224.569 249.01Z",
    fill: "url(#paint43_linear_17733_76152)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M128.757 279.999L97.1975 261.777C82.0917 253.059 83.9868 237.826 101.431 227.752L123.99 214.731C141.432 204.657 167.816 203.566 182.924 212.286L214.484 230.506C229.59 239.227 227.695 254.462 210.251 264.533L187.694 277.555C170.252 287.628 143.867 288.72 128.759 279.999H128.757Z",
    fill: "url(#paint44_linear_17733_76152)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M210.25 263.206L187.695 276.232C170.251 286.301 143.864 287.395 128.758 278.675L97.1987 260.455C90.8069 256.764 87.4921 251.9 87.079 246.759C86.6565 252.657 89.9482 258.35 97.1987 262.535L128.758 280.754C143.866 289.478 170.251 288.383 187.695 278.312L210.25 265.291C220.309 259.483 225.164 251.96 224.603 244.959C224.143 251.344 219.319 257.976 210.25 263.211V263.206Z",
    fill: "url(#paint45_radial_17733_76152)"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M169.653 141.805H142.666L113.32 241.132H113.334C113.334 241.246 113.32 241.361 113.32 241.476C113.32 255.255 132.5 266.427 156.161 266.427C179.821 266.427 199.001 255.255 199.001 241.476C199.001 241.361 198.987 241.246 198.985 241.132H199.001L169.655 141.805H169.653Z",
    fill: "url(#paint46_linear_17733_76152)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M198.999 241.132L193.173 221.416C193.189 221.651 193.205 221.885 193.205 222.122C193.205 234.033 176.62 243.694 156.161 243.694C135.702 243.694 119.115 234.031 119.115 222.122C119.115 221.885 119.131 221.651 119.145 221.416L113.318 241.132H113.332C113.328 241.245 113.318 241.36 113.318 241.475C113.318 255.254 132.498 266.426 156.159 266.426C179.819 266.426 198.999 255.254 198.999 241.475C198.999 241.36 198.985 241.245 198.983 241.132H198.999Z",
    fill: "url(#paint47_linear_17733_76152)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M181.405 181.581C181.412 181.717 181.428 181.851 181.428 181.992C181.428 190.117 170.115 196.705 156.158 196.705C142.202 196.705 130.887 190.117 130.887 181.992C130.887 181.832 130.919 181.682 130.926 181.525L124.984 201.638C124.991 201.825 124.998 201.968 124.998 202.056C124.998 212.074 138.948 220.199 156.158 220.199C173.369 220.199 187.316 212.074 187.316 202.056C187.316 201.97 187.337 201.834 187.351 201.714L181.402 181.581H181.405Z",
    fill: "url(#paint48_linear_17733_76152)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M169.655 141.805H169.648C169.648 141.823 169.655 141.839 169.655 141.858C169.655 146.2 163.614 149.715 156.162 149.715C148.711 149.715 142.668 146.2 142.668 141.858C142.668 141.839 142.672 141.823 142.672 141.805H142.668L136.779 161.733V161.922C136.779 168.157 145.456 173.212 156.162 173.212C166.868 173.212 175.543 168.157 175.543 161.922V161.733L169.655 141.805Z",
    fill: "url(#paint49_linear_17733_76152)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M167.244 141.412C167.244 144.537 162.279 147.069 156.159 147.069C150.04 147.069 145.072 144.537 145.072 141.412C145.072 138.286 150.035 135.754 156.159 135.754C162.283 135.754 167.244 138.286 167.244 141.412Z",
    fill: "url(#paint50_linear_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M167.423 138.272L158.697 139.953L167.998 239.317H168.002C168.023 239.428 168.041 239.541 168.065 239.654C170.671 253.186 178.985 262.959 186.637 261.482C194.285 260.007 198.378 247.844 195.769 234.315C195.748 234.202 195.723 234.091 195.7 233.978H195.705L167.423 138.268V138.272Z",
    fill: "url(#paint51_radial_17733_76152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M146.764 138.272L155.49 139.953L146.189 239.317H146.182C146.162 239.428 146.146 239.541 146.125 239.654C143.516 253.186 135.199 262.959 127.552 261.482C119.9 260.007 115.812 247.844 118.415 234.315C118.441 234.202 118.464 234.091 118.485 233.978H118.48L146.762 138.268L146.764 138.272Z",
    fill: "url(#paint52_radial_17733_76152)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_17733_76152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.343 343.123) scale(191.027 191.027)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#D73AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B828AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A51DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17733_76152",
    x1: 292.553,
    y1: 411.191,
    x2: -45.707,
    y2: 245.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17733_76152",
    x1: 291.701,
    y1: 409.82,
    x2: -44.0228,
    y2: 245.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17733_76152",
    x1: 290.894,
    y1: 408.449,
    x2: -42.3751,
    y2: 244.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17733_76152",
    x1: 290.13,
    y1: 407.089,
    x2: -40.759,
    y2: 244.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17733_76152",
    x1: 289.408,
    y1: 405.729,
    x2: -39.177,
    y2: 243.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_17733_76152",
    x1: 288.728,
    y1: 404.373,
    x2: -37.612,
    y2: 242.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_17733_76152",
    x1: 288.085,
    y1: 403.016,
    x2: -36.0694,
    y2: 241.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_17733_76152",
    x1: 287.473,
    y1: 401.661,
    x2: -34.542,
    y2: 240.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_17733_76152",
    x1: 286.882,
    y1: 400.316,
    x2: -33.039,
    y2: 239.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_17733_76152",
    x1: 286.322,
    y1: 398.967,
    x2: -31.5326,
    y2: 238.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_17733_76152",
    x1: 285.777,
    y1: 397.628,
    x2: -30.0368,
    y2: 237.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_17733_76152",
    x1: 16.0849,
    y1: 257.581,
    x2: 331.996,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A07BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A782BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B28FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C3A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCB2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DAC8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EEE6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBDFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_17733_76152",
    x1: 9.36519,
    y1: 249.307,
    x2: 313.287,
    y2: 249.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F054A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5824B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_17733_76152",
    x1: 12.7617,
    y1: 254.929,
    x2: 309.881,
    y2: 254.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_17733_76152",
    x1: 185.34,
    y1: 124.318,
    x2: -2699.18,
    y2: 28.4382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A07BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#A782BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#B28FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C2A2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_17733_76152",
    x1: 182.415,
    y1: 123.981,
    x2: -2702.1,
    y2: 28.0996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F27BD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_17733_76152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(323.551 69.7505) scale(138.074 138.074)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B93199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#8D2184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6A1574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#510D68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#420761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_17733_76152",
    x1: 356.997,
    y1: 102.452,
    x2: 116.002,
    y2: 173.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4916A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_17733_76152",
    x1: 356.689,
    y1: 102.633,
    x2: 116.515,
    y2: 173.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46159B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5E26BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7A28B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_17733_76152",
    x1: 356.379,
    y1: 102.816,
    x2: 117.027,
    y2: 173.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5D26B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7828B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_17733_76152",
    x1: 356.069,
    y1: 102.999,
    x2: 117.539,
    y2: 173.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41138E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5B25B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7528B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_17733_76152",
    x1: 355.763,
    y1: 103.182,
    x2: 118.05,
    y2: 173.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E1288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5A24B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7228B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_17733_76152",
    x1: 355.454,
    y1: 103.365,
    x2: 118.563,
    y2: 173.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B1182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5924B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6F28B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_17733_76152",
    x1: 355.145,
    y1: 103.548,
    x2: 119.076,
    y2: 172.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38117B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5823B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6D27B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_17733_76152",
    x1: 354.836,
    y1: 103.731,
    x2: 119.588,
    y2: 172.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5723AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6A27B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_17733_76152",
    x1: 354.528,
    y1: 103.913,
    x2: 120.102,
    y2: 172.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#320F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5622AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6727BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_17733_76152",
    x1: 354.219,
    y1: 104.097,
    x2: 120.614,
    y2: 172.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#300E69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5421A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6427BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_17733_76152",
    x1: 353.909,
    y1: 104.28,
    x2: 121.127,
    y2: 172.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D0D62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5321A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6227BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_17733_76152",
    x1: 139.66,
    y1: 143.68,
    x2: 353.598,
    y2: 143.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_17733_76152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(237.226 321.785) rotate(-22.34) scale(55.3927 36.5592)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_17733_76152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.587 200.749) rotate(-18.98) scale(42.4808 25.0636)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_17733_76152",
    x1: 412.183,
    y1: 430.401,
    x2: 344.577,
    y2: 270.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_17733_76152",
    x1: 138.444,
    y1: 179.471,
    x2: 216.048,
    y2: 301.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_17733_76152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.4768 154.65) scale(46.5073 46.5073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF75D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D74FC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B831B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#A51FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8A1596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#590D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#350743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1F032D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180226"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_17733_76152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.8535 155.349) scale(11.6678 11.6678)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#B8109B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5B0663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#500557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#37033C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#230226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#130114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#080008"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_17733_76152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(319.1 67.2793) scale(11.6699 11.6699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#B8109B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5B0663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#500557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#37033C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#230226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#130114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#080008"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_17733_76152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(242.944 343.076) scale(11.6699 11.6699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#B8109B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5B0663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#500557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#37033C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#230226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#130114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#080008"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_17733_76152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.714 277.33) rotate(-19.53) scale(43.1599 14.0739)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B5328C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7E2361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#51163E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2D0C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#14050F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#050104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_17733_76152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(236.893 275.127) rotate(31.82) scale(34.6564 15.8329)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B5328C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7E2361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#51163E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2D0C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#14050F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#050104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_17733_76152",
    x1: 166.967,
    y1: 141.412,
    x2: 142.415,
    y2: 141.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DC48C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_17733_76152",
    x1: -625.911,
    y1: 277.172,
    x2: -625.68,
    y2: 277.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A21BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C133B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DC48C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ED55C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E04BC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DC48C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_17733_76152",
    x1: 125.395,
    y1: 126.475,
    x2: 165.821,
    y2: 146.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_17733_76152",
    x1: 225.386,
    y1: 269.231,
    x2: 85.2352,
    y2: 269.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A21BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C133B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DC48C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ED55C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E04BC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DC48C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_17733_76152",
    x1: 236.919,
    y1: 91.6204,
    x2: 144.35,
    y2: 268.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_17733_76152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.755 266.367) scale(39.4172 39.4172)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_17733_76152",
    x1: 123.775,
    y1: 196.665,
    x2: 195.645,
    y2: 211.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E7DBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D5BFE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C7AEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#B396DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#A788DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A383DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#AD8DDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8A6DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_17733_76152",
    x1: 117.236,
    y1: 232.637,
    x2: 187.986,
    y2: 247.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C518A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CD2CAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CF30B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EB48BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A919AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AC17A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B714A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C211A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_17733_76152",
    x1: 125.691,
    y1: 192.407,
    x2: 196.446,
    y2: 207.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C518A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CD2CAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CF30B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EB48BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A919AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AC17A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B714A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C211A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_17733_76152",
    x1: 134.224,
    y1: 151.837,
    x2: 204.974,
    y2: 166.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C518A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CD2CAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CF30B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EB48BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A919AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AC17A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B714A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C211A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_17733_76152",
    x1: 156.159,
    y1: 137.026,
    x2: 156.159,
    y2: 178.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_17733_76152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(175.16 200.257) rotate(-10.9) scale(13.2986 40.2989)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0C033D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#070222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#03000F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#000003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_17733_76152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.291 199.99) rotate(-169.1) scale(13.2986 40.2989)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenancePc);
export default __webpack_public_path__ + "static/media/maintenance_pc.289f130515726fc348c11fe4c534817d.svg";
export { ForwardRef as ReactComponent };